import React, { useEffect, useMemo, useRef, useState } from 'react';
import Slider from 'react-slick';

import { CustomNextArrow, CustomPrevArrow } from './CustomSliderArrows';

import smallImageOne from '../../../main/assets/images/auvsi/computer-one.webp';
import smallImageTwo from '../../../main/assets/images/auvsi/computer-two.webp';
import smallImageThree from '../../../main/assets/images/auvsi/computer-three.webp';
import smallImageFour from '../../../main/assets/images/auvsi/computer-four.webp';

export const FlightComputer = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef<Slider>(null);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth < 1201);
      setIsMobile(window.innerWidth <= 834);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const smallImages = [
    { src: smallImageOne, alt: 'Computer view 1' },
    { src: smallImageTwo, alt: 'Computer view 2' },
    { src: smallImageThree, alt: 'Computer view 3' },
    { src: smallImageFour, alt: 'Computer view 4' },
  ];

  const sliderSettings = useMemo(() => {
    return {
      dots: false,
      infinite: true,
      speed: 200,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: !isTablet,
      prevArrow: <CustomPrevArrow />,
      nextArrow: <CustomNextArrow />,
      beforeChange: (_current: number, next: number) => setCurrentSlide(next),
    };
  }, [isTablet]);

  const handleImageSelect = (index: number) => {
    setCurrentSlide(index);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  };

  return (
    <section className="auvsi-computer-section">
      {isTablet && (
        <div className="auvsi-computer-images-container">
          {smallImages.map((image, index) => (
            <div
              key={index}
              className={`auvsi-computer-small-image-container ${
                currentSlide === index
                  ? 'auvsi-computer-small-image-selected'
                  : 'auvsi-computer-small-image-not-selected'
              }`}
              onClick={() => handleImageSelect(index)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="auvsi-computer-small-image"
              />
            </div>
          ))}
        </div>
      )}

      <div className="auvsi-computer-main-image-container">
        <div className="auvsi-bg-gradient" />
        <div className="auvsi-bg-noise" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 745 693"
          preserveAspectRatio="none"
          fill="none"
          className="auvsi-computer-main-image-lines"
        >
          <path
            d="M6 687H49V693H0V644H6V687ZM745 693H696V687H739V644H745V693ZM49 6H6V49H0V0H49V6ZM745 49H739V6H696V0H745V49Z"
            fill="white"
            fillOpacity="0.4"
            style={{ mixBlendMode: 'overlay' }}
          />
        </svg>

        <div className="auvsi-computer-main-image-box">
          {isMobile ? (
            <Slider ref={sliderRef} {...sliderSettings}>
              {smallImages.map((image, index) => (
                <div key={index} className="auvsi-slide-wrapper">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="auvsi-computer-main-image"
                  />
                </div>
              ))}
            </Slider>
          ) : (
            <img
              src={smallImages[currentSlide].src}
              alt={smallImages[currentSlide].alt}
              className="auvsi-computer-main-image"
            />
          )}
        </div>
      </div>

      <div className="auvsi-computer-right-section">
        <div className="auvsi-computer-text-container">
          <div className="auvsi-computer-titles-section">
            <h2 className="auvsi-computer-title">Orqa DTK APB</h2>
            <p className="auvsi-computer-description">
              The dawn of firmware-based FPV is here. It's time to embrace
              software-defined FPV drones with a whole new range of real-time
              capabilities enabled by advanced video processing, sensor
              integration, and AI. All on one tiny board, APB is your gateway to
              a new world of possibilities.
            </p>
          </div>
          <ul
            className="auvsi-computer-list"
            style={{ listStyleType: 'disc', marginLeft: '24px' }}
          >
            <li className="auvsi-computer-list-text">
              30mm x 60mm Flight Controller + Flight Computer
            </li>
            <li className="auvsi-computer-list-text">
              Analog and Digital Video In/Out
            </li>
            <li className="auvsi-computer-list-text">Real-time AI</li>
            <li className="auvsi-computer-list-text">Sensor Integration</li>
            <li className="auvsi-computer-list-text">
              Full access to onboard Linux OS
            </li>
          </ul>
        </div>

        {!isTablet && (
          <div className="auvsi-computer-images-container">
            {smallImages.map((image, index) => (
              <div
                key={index}
                className={`auvsi-computer-small-image-container ${
                  currentSlide === index
                    ? 'auvsi-computer-small-image-selected'
                    : 'auvsi-computer-small-image-not-selected'
                }`}
                onClick={() => handleImageSelect(index)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="auvsi-computer-small-image"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
